import { render, staticRenderFns } from "./TestCount.vue?vue&type=template&id=1c2662a0&scoped=true"
import script from "./TestCount.vue?vue&type=script&lang=js"
export * from "./TestCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2662a0",
  null
  
)

export default component.exports